import React from 'react';
import { SubHeading } from '../../components';
import { images } from '../../constants';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';


const Chef = () => (
  <div className='app__chef app__bg app__wrapper section__padding' id='chef'>
    <div className='app__chef_img' >
      <LazyLoadImage src={images.chef} alt='chef' effect='blur' />
    </div>
    <div className='app__chef_info' >
      <SubHeading title="Chef's Word" />
      <h1 className='headtext__cormorant' >What We Believe In</h1>
      <div className='app__chef-content' >
        <div className='app__chef-content_quote' >
          <img src={images.quote} alt='quote' />
          <p className='p__opensans' ><i>Food can be transformational, 
          more than just about the dish.</i></p>
        </div>
        <p className='p__opensans' ><i>This is why alongside delivering 
        the best dishes of various cuisines, we take importance in 
        creating great memories for our customers, through their 
        experience of the restaurant. <br /> For us, hospitality 
        isn't a job, it's a calling.</i></p>
        <div className='app__chef-sign' >
          <p className='app__chef-sign_name' >Ayo Tolu Sam</p>
          <p className='p__opensans' >Chef & Founder</p>
          <img src={images.sign} alt='signature' />
        </div>
      </div>
    </div>
  </div>
);

export default Chef;
